/**
 * Sidebar tab content for the agent chat: the same `<ChatSession>` the
 * full-page surface renders, handed the map controls so the agent can drive
 * the live map it's sitting next to.
 */

import React from 'react';

import {chatToolPermissionsFor} from 'app/components/AgentChat/chatToolPermissions';
import {MapControls} from 'app/components/AgentChat/types';
import CenteredSpinner from 'app/components/CenteredSpinner';
import {useAuth} from 'app/providers/AuthProvider';

// The Agents SDK and AI SDK are a sizeable chunk that only internal admins can
// reach, so keep them out of the main bundle.
const ChatSession = React.lazy(() => import('app/components/AgentChat'));

interface Props {
  mapControls: MapControls;
}

export default function ChatPanel({mapControls}: Props) {
  const auth = useAuth();

  if (auth.status !== 'logged in') {
    return null;
  }

  const toolPermissions = chatToolPermissionsFor(auth.profile, auth.currentOrganization);

  return (
    <React.Suspense fallback={<CenteredSpinner />}>
      <ChatSession
        firebaseUid={auth.firebaseUid}
        firebaseToken={auth.firebaseToken}
        mapControls={mapControls}
        toolPermissions={toolPermissions}
      />
    </React.Suspense>
  );
}
